import React, { useEffect, useMemo, useState } from "react";
import { DefaultLayout } from "../../layouts/DefaultLayout";
import { gameService } from "../../services/game.service";
import { gameStore } from "../../gStore/game.store";
import { userStore } from "../../gStore/user.store";
import { CarouselGame } from "../../components/atoms/Carousel";
import { GCCarouselGame } from "../../components/atoms/GameCenterCarousel";
import { navigate } from "../../utilities/CustomRoute/Navigate";
import { GAMES_ENABLED } from "../../utilities/url";
import { GamesCarousel } from "../../components/GamesCarousel";
import { Game } from "../../interfaces/game.interface";
import { FeedbackModal } from "../../components/atoms/FeedbackModal";
import { DailyChallengeSection } from "../../components/atoms/DailyChallengeSection";

function Home() {
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedGame, setSelectedGame] = useState<Game>();
  const [showFeedback, setShowFeedback] = useState(false);
  const onCloseModal = () => setShowFeedback(false);

  useEffect(() => {
    setLoading(true);
    gameService
      .getGames(userStore.data.user.id)
      .then((_games) => {
        gameStore.setGames({ payload: { games: _games } });
      })
      .catch((errMessage) => {
        console.log(errMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const thirtyDaysAgo = useMemo(() => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  }, []);

  return (
    <DefaultLayout title="Home">
      {loading ? (
        <div className="w-full p-10 flex justify-center text-white">
          Loading...
        </div>
      ) : (
        <>
          <FeedbackModal
            game={selectedGame}
            showFeedback={showFeedback}
            onCloseModal={onCloseModal}
            setShowFeedback={setShowFeedback}
          />

          <section className="py-0">
            {GAMES_ENABLED ? (
              <CarouselGame games={gameStore.data.games} />
            ) : (
              <GCCarouselGame games={gameStore.data.games} />
            )}
          </section>

          <DailyChallengeSection />

          <GamesCarousel
            title="New Releases"
            games={gameStore.data.games
              .filter((game) => new Date(game.released_at) > thirtyDaysAgo)
              .sort((a, b) => (a.released_at > b.released_at ? -1 : 1))}
            navigateSort="released_at"
            setSelectedGame={setSelectedGame}
            setShowFeedback={setShowFeedback}
          />

          <GamesCarousel
            title="Top Games"
            games={gameStore.data.games.filter((game) => game.trending)}
            navigateSort="trending"
            setSelectedGame={setSelectedGame}
            setShowFeedback={setShowFeedback}
          />

          <section className="py-8">
            <div className="flex justify-center">
              <button
                onClick={() => navigate("games")}
                className="cursor-pointer font-medium text-[14px] btnStyle text-black"
              >
                All Games
              </button>
            </div>
          </section>
        </>
      )}
    </DefaultLayout>
  );
}

export default Home;
